/**
 * Auth setup for Falcon using @roselabs-io/saas-shell
 *
 * This configures the AuthProvider for Falcon's specific needs.
 */

import { createAuthProvider, useAuth } from '@roselabs-io/saas-shell'
import type { User, Team, LoginResult, AuthContextType } from '@roselabs-io/saas-shell'
import { teamsApi } from '../api/teams'

const AUTH_SERVICE_URL = import.meta.env.VITE_AUTH_API_URL || 'http://localhost:8000'
const FALCON_API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8003'

// Create auth provider configured for Falcon
export const { AuthProvider, authApi, tokenManager } = createAuthProvider({
  authServiceUrl: AUTH_SERVICE_URL,
  productApiUrl: FALCON_API_URL,
  storageKeyPrefix: 'falcon',
  loginPath: '/login',
  productSlug: 'falcon',
})

// Re-export the fetchUserTeams function that AuthProvider needs
export const fetchUserTeams = async () => {
  return teamsApi.getUserTeams()
}

// Default team path for Falcon (after team selection)
export const defaultTeamPath = '/dashboard'

// Re-export types and hooks from saas-shell for convenience
export { useAuth }
export type { User, Team, LoginResult, AuthContextType }

// Re-export token management functions
export const { getAccessToken, getRefreshToken, setTokens, clearTokens } = tokenManager
